export const sharedDropdownContent = {
    backgroundColor: '$dropdownBackground',
    border: '1px solid $dropdownBorder',
    borderRadius: '$dropdownBorder',
    boxShadow: '0px 5px 15px $dropdownShadow',
    boxSizing: 'border-box',
    margin: '$dropdownMargin 0 0',
    maxWidth: '300px',
    minWidth: '220px',
    position: 'absolute',
}

export const styledDropdown = {
    '& button': {
        flexGrow: 1,
        justifyContent: 'flex-start',
    },
    'position': 'relative',
}

export const styledItem = {
    display: 'flex',
    flexDirection: 'column',
}

export const queueName = {
    compoundVariants: [
        {
            css: {opacity: 0.6},
            isGroupQueue: true,
            status: '',
        },
    ],
    variants: {
        isGroupQueue: {true: {}},
        status: {
            hidden: {},
            highlight: {},
            unread: {},
            visible: {},
        },
    },
}
